import React, { memo } from "react";
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#AA00FF", "#FF0055"];

const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * Math.PI / 180);
  const y = cy + radius * Math.sin(-midAngle * Math.PI / 180);

  return (
    <text x={x} y={y} fill="#fff" textAnchor="middle" dominantBaseline="central"
      style={{ fontSize: "12px", fontFamily: "IRANSans" }}>
      {(percent * 100).toFixed(1)}٪
    </text>
  );
};

const PieChartComponent = ({ data }) => (
  <div className="flex justify-center items-center w-full">
    <PieChart width={350} height={280}>
      <Pie
        data={data}
        dataKey="totalSales"
        nameKey="productGroup"
        cx="50%"
        cy="50%"
        outerRadius={100}
        label={renderCustomizedLabel}
        labelLine={false}
      >
        {data.map((e, i) => (
          <Cell key={i} fill={COLORS[i % COLORS.length]} />
        ))}
      </Pie>

      <Tooltip wrapperStyle={{ fontFamily: "IRANSans", fontSize: "12px" }} />
      <Legend verticalAlign="bottom" align="center" />
    </PieChart>
  </div>
);

//  React.memo یعنی فقط وقتی data تغییر کند دوباره رندر می‌شود!
export default memo(PieChartComponent);
